import { render, staticRenderFns } from "./Decoration12.vue?vue&type=template&id=731d3aa5&scoped=true"
import script from "./Decoration12.vue?vue&type=script&lang=js"
export * from "./Decoration12.vue?vue&type=script&lang=js"
import style0 from "./Decoration12.vue?vue&type=style&index=0&id=731d3aa5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731d3aa5",
  null
  
)

export default component.exports